import { render } from "./audit-log.vue?vue&type=template&id=51d42977&ts=true"
import script from "./audit-log.vue?vue&type=script&lang=ts"
export * from "./audit-log.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__